import { Box } from "@mui/material";
const UserImage = ({ image, size = "60px" }) => {
  return (
    <Box
      className="user-image-container"
      width={size}
      height={size}
      sx={{
        aspectRatio: '1 / 1',
        flex: `0 0 ${size}`,
        flexShrink: 0,
        height: size,
        maxHeight: size,
        maxWidth: size,
        minHeight: size,
        minWidth: size,
        overflow: 'hidden',
        width: size,
      }}
    >
      <img
        className="user-image-avatar"
        style={{
          aspectRatio: '1 / 1',
          borderRadius: '50%',
          display: 'block',
          height: '100%',
          maxHeight: '100%',
          maxWidth: '100%',
          minHeight: '100%',
          minWidth: '100%',
          objectFit: 'cover',
          width: '100%',
        }}
        width={size}
        height={size}
        alt="user"
        src={image} 
      />
    </Box>
  );
};

export default UserImage;

